/**
 * Formats a duration in milliseconds to a human-readable string.
 *
 * Rules:
 * - No leading zeros
 * - If time is less than one minute, only show seconds
 * - If time is more than one day, only show days (e.g., 27 hours = "1d")
 * - If a "middle" unit's duration is 0, omit it entirely (e.g., 1h 45s, not 1h 0m 45s)
 */
export function formatDuration(milliseconds: number): string {
  if (milliseconds < 0) {
    return '0s'
  }

  const totalSeconds = Math.floor(milliseconds / 1000)
  const totalMinutes = Math.floor(totalSeconds / 60)
  const totalHours = Math.floor(totalMinutes / 60)
  const totalDays = Math.floor(totalHours / 24)

  // If more than one day, only show days
  if (totalDays >= 1) {
    return `${totalDays}d`
  }

  // If less than one minute, only show seconds
  if (totalMinutes < 1) {
    return `${totalSeconds}s`
  }

  const hours = totalHours
  const minutes = totalMinutes % 60
  const seconds = totalSeconds % 60

  const parts: string[] = []

  if (hours > 0) {
    parts.push(`${hours}h`)
  }

  if (minutes > 0) {
    parts.push(`${minutes}m`)
  }

  if (seconds > 0) {
    parts.push(`${seconds}s`)
  }

  return parts.join(' ')
}
